import { render, staticRenderFns } from "./PresentationBookmarked.vue?vue&type=template&id=4f2fffe0"
import script from "./PresentationBookmarked.vue?vue&type=script&lang=ts"
export * from "./PresentationBookmarked.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports